<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12.9 19.6q-.9.8-1.8 0L4.4 13q-.7-.9 0-1.8L11 4.4a1.3 1.3 0 1 1 2 1.8L7 12l5.9 5.8q.7.9 0 1.8"
    />
    <path
      d="M19.6 19.6q-.9.8-1.8 0L11.1 13q-.7-.9 0-1.8l6.7-6.7a1.3 1.3 0 1 1 1.8 1.8L13.8 12l5.8 5.8q.8.9 0 1.8"
    />
  </svg>
</template>
